import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import dynamic from 'next/dynamic';
import { APP_URLS } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import JobOffersListComponent from './components/JobOffersListComponent';
import { JobOffersListPageProps } from './JobOffersListPage.types';

const JobOfferURLNonExistModal = dynamic(
  () => import('./components/JobOfferURLNonExistModal'),
  { ssr: false }
);

export const JobOffersListPage: React.FC<JobOffersListPageProps> = (props) => {
  const { t } = useI18n('job-offer-list');

  usePageTrack('Website - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('page_title')}
        desc={t('page_description')}
        url={APP_URLS.jobOffers}
        imgUrl={`${props.baseUrl}${getPublicPath(
          '/images/cards/card_offers.png'
        )}`}
        indexable={true}
      />
      <JobOffersListComponent
        currencies={props.currencies}
        languages={props.languages}
        techs={props.techs}
        techRoles={props.techRoles}
        allLanguages={props.allLanguages}
      />
      <JobOfferURLNonExistModal />
    </>
  );
};
